<template>
    <div>
        <CounterList ref="CounterList" :queryParam="queryParam"></CounterList>
    </div>
</template>

<script>
    import CounterList from "./List/CounterList";

    export default {
        name: "PmCounterManagementRightList",
        props:[
            'counterTreeNode'
        ],
        components: {
            CounterList
        },
        data(){
            return {
                queryParam:{
                    neTypeCode: '',
                    measureObjTypeCode: '',
                    measureObjCode: '',
                    neVersion: ''
                },
                isTreeSelectedFlag: false, // 判断tab切换是否为树点击事件触发
                isInit: true //判断是否为初始化状态，第一次点击树后该标志置为false
            }
        },
        methods: {
        },
        watch: {
            counterTreeNode(counterTreeNode){
                let neTypeCode = '';
                let measureObjTypeCode = '';
                let measureObjCode = '';

                const nodeId = counterTreeNode.nodeData.id;
                const neVersion = nodeId.split("_")[1];
                const neParam = nodeId.split("_")[0];

                if(neParam.length == 3){
                    neTypeCode = neParam;
                } else if(neParam.length == 6){
                    measureObjTypeCode = neParam;
                } else if(neParam.length == 10){
                    measureObjCode = neParam
                }

                this.queryParam = {
                    neTypeCode: neTypeCode,
                    measureObjTypeCode: measureObjTypeCode,
                    measureObjCode: measureObjCode,
                    neVersion: neVersion
                }
                this.$refs.CounterList.$refs.CounterListContent.$refs.pagerOfcounterDataList.ej2Instances.currentPage = 1;
                this.$refs.CounterList.$refs.CounterListToolBar.counterName = "";
                this.$refs.CounterList.$refs.CounterListContent.counterName = null;
                this.$refs.CounterList.$refs.CounterListContent.getCounterListData(this.queryParam);
                this.isTreeSelectedFlag = true;
                this.isInit = false;
            }
        }
    }
</script>

<style scoped>

</style>
